(() => {
  const topBrands = document.querySelector(".js-top-brands");

  const [child1, child2, child3] = Array.from(topBrands.children);
  const siblings = [child2, child3];

  siblings.forEach((sibling) => {
    sibling.addEventListener("mouseenter", () => {
      sibling.classList.add("active");
      child1.classList.remove("active");
    });

    sibling.addEventListener("mouseleave", () => {
      sibling.classList.remove("active");
      child1.classList.add("active");
    });
  });

  const topBrandsSwiper = new Swiper(".js-top-brands-swiper", {
    centerInsufficientSlides: true,
    slidesPerView: "auto",
    spaceBetween: 24,
  });
})();
